module.exports = __webpack_public_path__ + "16a8b399080d96ca80b8e5b91e198a4c.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/difficulty_5.png
// module id = 77
// module chunks = 0